import { render } from "./questionMark.vue?vue&type=template&id=21b5a80e&scoped=true"
import script from "./questionMark.vue?vue&type=script&lang=js"
export * from "./questionMark.vue?vue&type=script&lang=js"

import "./questionMark.vue?vue&type=style&index=0&id=21b5a80e&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b5a80e"]])

export default __exports__